import axios from 'axios'

const API_PATH = 'admins/marketing/products'

const MarketingProductsApi = {
  /**
   * get all the products that are bulk discountable
   * and eligible for being uploaded to show their price and revenue potential
   * @returns CSV of products
   */
  csv: async () => {
    const path = `${API_PATH}/csv.csv`

    const response = await axios.get(path, {})
    return response
  },

  /**
   * Post bulk discount CSV file to get the previous products price
   * Invoke `GET api/v2/admins/products
   * @param {object} file - Bulk discount CSV file
   */
  showPrice: async ( file ) => {
    const path  = `${API_PATH}/show_price`
    let payload = new FormData()
    payload.append('file', file)
    const response = await axios.post(path, payload)
    return response
  }
}

export default MarketingProductsApi